import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Ionicon from 'react-ionicons';
import Classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getFundUrl } from '../../functions/functions';
import './ResultRow.css';
import {
    clearFund, openExternalLinkModal
} from '../../actions/actions';

var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
});


class ResultRow extends PureComponent {

    constructor(props) {
        super(props);
        this.handleClearFund = this.handleClearFund.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
    }

    // Clear out the fund result set
    handleClearFund = () => {
        // console.log('Clear Fund with ticker: ' + this.props.result.inputFund.ticker);
        this.props.clearFund(this.props.result.inputFund.externalID);
    }

    handleOpenModal(url, type) {
        // console.log('Open Modal with url: ' + url);
        if (type !== 'WTETF') {
            this.props.openExternalLinkModal(url);
        } else {
            var win = window.open(url, '_blank');
            win.focus();
        }
    }

    // Format any number as a percent
    formatPercent(number) {
        return (
            number !== null ? parseFloat(number * 100).toFixed(2) + "%" : '-'
        )
    }

    // Render either a Check mark to cancel the fund of a link to a winning WT fund
    renderCheckMark(rowType, fund) {
        if (rowType === 'cginput') {
            return (
                <div className="number action" onClick={this.handleClearFund}>✕</div>
            )
        } else if (rowType === 'wtSwap') {
            return (
                <div className="number" >
                    {/* <Ionicon icon="ios-link" fontSize="25px" color="#5B6770" rotate={true} onClick={() => window.open(fund.fundPageURL)} /> */}
                    <strong>POTENTIAL FOR SWAP</strong>
                </div>
            )
        }

    }

    // Take out the relevant Cap Gain (by type)
    extractCapGain(distributions, type, fundType) {

        // If we want to hide the WT cap gains (based on the the showWTSwapsWithCapGains flag) then
        // return nothing
        if (fundType === 'WTETF' && this.props.showWTSwapsWithCapGains === false) {
            return null;
        } else if (distributions && distributions.length > 0) {

            var capGains = distributions.filter(dist => {
                return dist.distributionType === type;
            })

            return (capGains && capGains.length > 0) ? capGains[0] : null;

        } else {
            return null;
        }
    }

    // Render the Capital Gains rows
    renderCapGains(fund, rowType) {

        // Get latest NAV for each fund
        var monthEndNAV = fund.levels !== null ? fund.levels.monthEndNAV.slice(-1)[0] : null;

        // Get the cap gain objects if available
        var shortTermCapGain = this.extractCapGain(fund.estimatedCapGainsDistributions, 'estimated_capgain_short', fund.type);
        var longTermCapGain = this.extractCapGain(fund.estimatedCapGainsDistributions, 'estimated_capgain_long', fund.type);
        var totalCapGain = this.extractCapGain(fund.estimatedCapGainsDistributions, 'estimated_capgain_total', fund.type);

        // Fill in the total cap gain if it wasn't provided (but we have short or long)
        if (!totalCapGain && (shortTermCapGain || longTermCapGain)) {
            totalCapGain = {
                paymentDate: shortTermCapGain ? shortTermCapGain.paymentDate : longTermCapGain.paymentDate,
                exDate: shortTermCapGain ? shortTermCapGain.exDate : longTermCapGain.exDate,
                distributionType: 'estimated_capgain_total',
                currency: 'USD',
                value: shortTermCapGain && longTermCapGain ? shortTermCapGain.value + longTermCapGain.value :
                    (shortTermCapGain ? shortTermCapGain.value : longTermCapGain.value),
            }
        }

        var capGainPercentage = (totalCapGain !== null && monthEndNAV !== null && monthEndNAV > 0)
            ? parseFloat((totalCapGain.value / monthEndNAV) * 100).toFixed(2) + "%" : '-';

        var url = getFundUrl(fund);

        // Get the current date (with no hours)
        var currentDate = new Date().setHours(0, 0, 0, 0);
        var exDatePassed = false;

        // If the exDate has already past on the input fund
        // then set a flag so we can highlight that to the user
        if (rowType === 'cginput' && totalCapGain !== null) {

            var exDate = new Date(totalCapGain.exDate).setHours(0, 0, 0, 0);
            
            if (currentDate >= exDate) {
                exDatePassed = true;
            }

        }

        // Return an message if the cap gain has been paid
        // Otherwise return cap gains information
        if (exDatePassed) {
            return (
                <tr className={Classnames(rowType, 'cap-gains-results-row')} key={fund.ticker}>
                    <th scope="row" className='left'>
                        <a href="#null" onClick={() => { this.handleOpenModal(url, fund.type) }}>{fund.ticker}
                        </a>
                    </th>
                    <td className='hidden-xs left' ><div>{fund.name.replace(/&amp;/g, '&')}</div></td>
                    <td colspan='6'>
                        <div className='number'>
                            This fund's capital gains have already been distributed for the year
                        </div>
                    </td>
                    <td>
                        {this.renderCheckMark(rowType, fund)}
                    </td>
                </tr>
            )
            // If there is no Capital gains, or WT cap gains haven't been published yet then show an 
            // error message
        } else if (totalCapGain === null && (fund.type !== 'WTETF' || this.props.showWTUnpublishedMsg)) {
        
            return (
                <tr className={Classnames(rowType, 'cap-gains-results-row')} key={fund.ticker}>
                    <th scope="row" className='left'>
                        <a href="#null" onClick={() => { this.handleOpenModal(url, fund.type) }}>{fund.ticker}
                        </a>
                    </th>
                    <td className='hidden-xs left' ><div>{fund.name.replace(/&amp;/g, '&')}</div></td>
                    <td colSpan='6'>
                        <div className='number'>
                            Capital gains estimates are not available for this fund. Please check fund's website
                        </div>
                    </td>
                    <td>
                        {this.renderCheckMark(rowType, fund)}
                    </td>
                </tr>
            )
        
        } else {
            return (
                <tr className={Classnames(rowType, 'cap-gains-results-row')} key={fund.ticker}>
                    <th scope="row" className='left'>
                        <a href="#null" onClick={() => { this.handleOpenModal(url, fund.type) }}>{fund.ticker}
                        </a>
                    </th>
                    <td className='hidden-xs left' ><div>{fund.name.replace(/&amp;/g, '&')}</div></td>

                    <td>
                        <div className='number'>
                            {totalCapGain !== null ?
                                new Date(totalCapGain.exDate).toLocaleDateString() :
                                '-'}
                        </div>
                    </td>
                    <td>
                        <div className='number'>
                            {totalCapGain !== null ?
                                new Date(totalCapGain.paymentDate).toLocaleDateString() :
                                '-'}
                        </div>
                    </td>
                    <td>
                        <div className='number'>{shortTermCapGain !== null ?
                            formatter.format(shortTermCapGain.value) : '-'}
                        </div>
                    </td>
                    <td>
                        <div className='number'>{longTermCapGain !== null ?
                            formatter.format(longTermCapGain.value) : '-'}
                        </div>
                    </td>
                    <td>
                        <div className='number'>{totalCapGain !== null ?
                            formatter.format(totalCapGain.value) : '-'}
                        </div>
                    </td>
                    <td>
                        <div className='number'>
                            {capGainPercentage}
                        </div>
                    </td>
                    <td>
                        {this.renderCheckMark(rowType, fund)}
                    </td>
                </tr>
            )
        }

    }

    // Render the Performance rows
    renderPerformance(fund, rowType) {

        // Don't return anything is performance is missing
        if (fund.stdPerformance === null) {
            return null;
        }
        var url = getFundUrl(fund);

        return (

            <tr className={Classnames(rowType, 'cap-gains-results-row')} key={fund.ticker}>
                <th scope="row" className='left'>
                    <a href="#null" onClick={() => { this.handleOpenModal(url, fund.type) }}>{fund.ticker}</a>
                </th>
                <td className='hidden-xs left'>
                    <span>
                        {fund.name.replace(/&amp;/g, '&') + ' (NAV)'}
                    </span>
                    <span>
                        <br />
                        {fund.name.replace(/&amp;/g, '&') + ' (MP)'}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].mtdNAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].mtdMP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].mos3NAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].mos3MP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].ytdNAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].ytdMP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs1NAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs1MP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs3NAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs3MP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs5NAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs5MP)}
                    </span>
                </td>
                <td className='number'>
                    <span className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs10NAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].yrs10MP)}
                    </span>
                </td>
                <td className='number'>
                    <span >
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].inceptionNAV)}
                    </span>
                    <span className='number'>
                        <br />
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].inceptionMP)}
                    </span>
                </td>
                <td>
                    {this.renderCheckMark(rowType, fund)}
                </td>
            </tr>

        )
    }

    // Render the Fund Details rows
    renderFundDetails(fund, rowType) {

        var url = getFundUrl(fund);
        var urlFilings = fund.type === 'WTETF' ? 'https://www.wisdomtree.com/resource-library/prospectus-regulatory-reports' :
            'https://doc.morningstar.com/docdetail.aspx?clientid=schwab&key=84b36f1bf3830e07&cusip=' + fund.externalID;

        return (
            <tr className={Classnames(rowType, 'cap-gains-results-row')} key={fund.ticker}>
                <th scope="row" className='left'>
                    <span>
                        {fund.ticker}
                    </span>
                </th>
                <td className='link'>
                    <div>
                        
                        <a href="#null" onClick={() => { this.handleOpenModal(url, fund.type) }}>
                            <FontAwesomeIcon icon="external-link-alt" size="md" />
                        </a>
                    </div>
                </td>
                <td className='link'>
                    <div>
                        <a href="#null" onClick={() => { this.handleOpenModal(urlFilings, fund.type) }}>
                            <FontAwesomeIcon icon="external-link-alt" size="md" />
                        </a>
                    </div>
                </td>
                <td>
                    <div className='number'>
                        {new Date(fund.inceptionDate).toLocaleDateString()}
                    </div>
                </td>
                <td>
                    <div className='number'>
                        {(fund.expenseRatio * 10000).toFixed(0) + 'bps'}
                    </div>
                </td>
                <td>
                    <div className='number'>
                        {(fund.expenseRatioGross * 10000).toFixed(0) + 'bps'}
                    </div>
                </td>
                <td>
                    <div className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].sec30DayYieldSub)}
                    </div>
                </td>
                <td>
                    <div className='number'>
                        {this.formatPercent(fund.stdPerformance.slice(-1)[0].sec30DayYieldUnSub)}
                    </div>
                </td>
                <td>
                    <div className='left expense-notes'>
                        {fund.expenseNotes}
                    </div>
                </td>
                <td>
                    {this.renderCheckMark(rowType, fund)}
                </td>
            </tr>
        )
    }

    // Take an array of funds and render each row
    renderRows(funds) {

        // Save the exDate of the inputFund to use as comparison to WT funds
        var exDateOfInput = (funds[0].estimatedCapGainsDistributions ? new Date(funds[0].estimatedCapGainsDistributions[0].exDate) : null);

        return (

            // For each fund either render the CapGain view or the Performance view
            funds.map((fund, index) => {

                // Identify if the WT fund has a closer exDate so is eligible for a swap (or if the WT fund doesn't have
                // and estimated cap gains this year)
                // If we don't want to show WT Cap Gains yet but ensure the swap is right, check the showWTSwapsWithCapGains flag
                var rowType;
                if (index === 0) {
                    rowType = 'cginput';
                    // If the exDate exists, is greater than today, and the replacement fund's
                    // exDate is earlier then it can be swapped
                } else if ((exDateOfInput && exDateOfInput > new Date() && !fund.estimatedCapGainsDistributions) ||
                    (exDateOfInput && exDateOfInput > new Date() && fund.estimatedCapGainsDistributions &&
                        exDateOfInput > new Date(fund.estimatedCapGainsDistributions[0].exDate) &&
                        this.props.showWTSwapsWithCapGains
                    )) {
                    rowType = 'wtSwap';
                } else {
                    rowType = 'wtNoSwap';
                }

                switch (this.props.fundListType) {

                    case 'capgains':
                        return (this.renderCapGains(fund, rowType));
                    case 'performance':
                        return (this.renderPerformance(fund, rowType));
                    case 'funddetails':
                        return (this.renderFundDetails(fund, rowType));
                    default:
                        return null;
                }

            })

        )
    }

    render() {

        const result = this.props.result;

        if (this.props.showWTFunds && result.wtFunds !== null && result.wtFunds.length > 0) {

            return (
                this.renderRows([result.inputFund].concat(result.wtFunds))
            )

        } else {

            return (
                this.renderRows([result.inputFund])
            )

        }

    }

}

function mapStateToProps(state) {
    return {
        showWTFunds: state.fundData.showWTFunds,
        showWTSwapsWithCapGains: state.params.showWTSwapsWithCapGains,
        showWTUnpublishedMsg: state.params.showWTUnpublishedMsg,
    };
}

export default connect(mapStateToProps, { clearFund, openExternalLinkModal })(ResultRow);


// WEBPACK FOOTER //
// ./src/components/FundList/ResultRow.js